export const de = {
  // Navigation
  nav: {
    home: 'Home',
    services: 'Leistungen',
    about: 'Über uns',
    contact: 'Kontakt',
    implants: 'Implantate',
    veneers: 'Veneers',
    technology: 'Technologien',
    book: 'Online Termin buchen',
    emergency: 'Notdienst 24/7',
    privacyPolicy: 'Datenschutz',
    legalNotice: 'Impressum'
  },

  implants: {
    title: 'Implantate – Für mehr Lebensqualität',
    intro: 'Zahnimplantate sind die modernste und natürlichste Art, fehlende Zähne zu ersetzen. Sie bieten nicht nur eine perfekte Ästhetik, sondern geben Ihnen auch das Gefühl und die Sicherheit eigener Zähne zurück. In unserer Praxis in Palma setzen wir auf höchste Qualitätsstandards und modernste Verfahren.',
    benefitsTitle: "Vorteile von Implantaten",
    benefit1: "Natürliches Aussehen und Gefühl, vergleichbar mit eigenen Zähnen",
    benefit2: "Verbesserung der Kaufunktion und Sprechfähigkeit",
    benefit3: "Langlebige Lösung mit hoher Erfolgsrate",
    benefit4: "Erhalt der Kieferknochenstruktur",
    qualityTitle: "Höchste Qualität und Präzision",
    quality: "Wir verwenden ausschließlich hochwertige Materialien und modernste digitale Planungsverfahren. So garantieren wir Ihnen ein präzises und langlebiges Ergebnis, das perfekt zu Ihnen passt.",
    experienceTitle: "Angenehme Behandlungserfahrung",
    experience: "Dank minimalinvasiver Techniken und sanfter Betäubung ist die Behandlung bei uns besonders schonend. Unser Ziel ist es, dass Sie sich während des gesamten Prozesses wohl und sicher fühlen.",
    processTitle: "Der Weg zu Ihren neuen Implantaten",
    step1Title: "Beratung",
    step1: "Ausführliches Gespräch und individuelle Planung",
    step2Title: "Implantation",
    step2: "Schonender Eingriff unter örtlicher Betäubung",
    step3Title: "Einheilung",
    step3: "Verwachsung des Implantats mit dem Kieferknochen",
    step4Title: "Zahnersatz",
    step4: "Anfertigung und Einsetzen des individuellen Zahnersatzes"
  },
  veneers: {
    title: 'Veneers – Für Ihr strahlendes Lächeln',
    intro: 'Hauchdünne Keramikschalen, sogenannte Veneers, bieten eine elegante Lösung, um kleine Schönheitsfehler an den Frontzähnen dauerhaft zu korrigieren. Ob Verfärbungen, kleine Lücken oder leichte Fehlstellungen – wir verhelfen Ihnen zu einem harmonischen und natürlichen Lächeln.',
    imageAlt: "Veneers Behandlung bei SeaDent Mallorca",
    description: "Veneers sind individuell gefertigte Verblendschalen, die fest auf die Zahnoberfläche geklebt werden. Sie zeichnen sich durch ihre hohe Biokompatibilität und eine Ästhetik aus, die von natürlichen Zähnen kaum zu unterscheiden ist. In nur wenigen Sitzungen verwandeln wir Ihr Lächeln und schenken Ihnen neues Selbstbewusstsein."
  },

  // Header
  header: {
    logoText: "SeaDent Mallorca",
    phone: "603 31 96 48",
    whatsapp: "WhatsApp",
    languageToggle: "ES",
    reviews: {
      rating: "5.0",
      count: "470+ Rezensionen",
      google: "Google Bewertungen"
    }
  },

  // Common
  common: {
    loading: 'Laden...',
    error: 'Ein Fehler ist aufgetreten',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    clear: 'Löschen',
    refresh: 'Aktualisieren',
    search: 'Suchen',
    filter: 'Filter',
    actions: 'Aktionen',
    status: 'Status',
    date: 'Datum',
    time: 'Zeit',
    email: 'E-Mail',
    phone: 'Telefon',
    notes: 'Notizen',
    created: 'Erstellt',
    updated: 'Aktualisiert',
    name: 'Name',
    description: 'Beschreibung',
    duration: 'Dauer',
    color: 'Farbe',
    yes: 'Ja',
    no: 'Nein',
    confirm: 'Bestätigen',
    minutes: 'Minuten',
    bookNow: 'Jetzt buchen'
  },

  // Cookie Consent
  cookieConsent: {
    title: "Cookie-Einstellungen",
    description: "Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch die Nutzung unserer Website erklären Sie sich mit unserer Cookie-Richtlinie einverstanden.",
    acceptAll: "Alle akzeptieren",
    acceptNecessary: "Nur notwendige",
    settings: "Einstellungen",
    save: "Einstellungen speichern",
    close: "Schließen",
    privacyPolicy: "Datenschutzrichtlinie",
    categories: {
      necessary: {
        title: "Notwendig",
        description: "Diese Cookies sind für das Funktionieren der Website erforderlich und können nicht deaktiviert werden."
      },
      preferences: {
        title: "Präferenzen",
        description: "Diese Cookies ermöglichen es der Website, sich an von Ihnen vorgenommene Auswahlmöglichkeiten zu erinnern."
      },
      statistics: {
        title: "Statistiken",
        description: "Diese Cookies helfen uns zu verstehen, wie Besucher mit der Website interagieren."
      },
      marketing: {
        title: "Marketing",
        description: "Diese Cookies werden verwendet, um Besuchern relevante Anzeigen und Marketingkampagnen anzuzeigen."
      }
    }
  },

  // Admin
  admin: {
    title: 'Admin Dashboard',
    login: 'Anmelden',
    logout: 'Abmelden',
    dashboard: 'Dashboard',
    username: 'Benutzername',
    password: 'Passwort',
    loginButton: 'Anmelden',
    loginError: 'Ungültige Anmeldedaten',
    loginRequired: 'Bitte melden Sie sich an, um auf das Admin-Panel zuzugreifen',
    welcome: 'Willkommen im Admin Dashboard',
    overview: 'Übersicht',
    quickActions: 'Schnellaktionen',
    recentActivity: 'Letzte Aktivitäten',
    systemStatus: 'Systemstatus',
    googleCalendarStatus: 'Google Calendar',
    databaseStatus: 'Datenbank',
    connected: 'Verbunden',
    disconnected: 'Getrennt',
    healthy: 'Gesund',
    error: 'Fehler'
  },

  // Calendar
  calendar: {
    title: 'Terminkalender',
    next: 'Weiter',
    previous: 'Zurück',
    today: 'Heute',
    month: 'Monat',
    week: 'Woche',
    day: 'Tag',
    noEvents: 'Keine Termine in diesem Zeitraum',
    filterBy: 'Filtern nach',
    allProviders: 'Alle Behandler',
    allProcedures: 'Alle Behandlungen',
    allOperatories: 'Alle Behandlungsräume',
    refresh: 'Kalender aktualisieren',
    googleCalendarSync: 'Synchronisiert...'
  },

  // Appointments
  appointments: {
    title: 'Termine',
    create: 'Termin erstellen',
    edit: 'Termin bearbeiten',
    update: 'Termin aktualisieren',
    view: 'Termin anzeigen',
    delete: 'Termin löschen',
    cancel: 'Termin stornieren',
    confirm: 'Bestätigen',
    completed: 'Als abgeschlossen markieren',
    noShow: 'Nicht erschienen',
    patient: 'Patient',
    provider: 'Behandler',
    procedure: 'Behandlung',
    operatory: 'Behandlungsraum',
    date: 'Datum',
    time: 'Zeit',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    status: 'Status',
    notes: 'Notizen',
    language: 'Sprache',
    total: 'Gesamttermine',
    today: 'Heute',
    thisWeek: 'Diese Woche',
    thisMonth: 'Dieser Monat',
    upcoming: 'Kommende',
    recent: 'Letzte',
    search: 'Termine suchen...',
    filters: 'Filter',
    exportToExcel: 'Nach Excel exportieren',
    importFromExcel: 'Aus Excel importieren',
    bulkActions: 'Massenaktionen',
    selectAll: 'Alle auswählen',
    selectedCount: 'Ausgewählt: {count}',
    conflictDetected: 'Terminkonflikt erkannt',
    googleCalendarEvent: 'Google Calendar Ereignis',
    syncWithGoogleCalendar: 'Mit Google Calendar synchronisieren',
    createGoogleCalendarEvent: 'Google Calendar Ereignis erstellen',
    updateGoogleCalendarEvent: 'Google Calendar Ereignis aktualisieren',
    deleteGoogleCalendarEvent: 'Google Calendar Ereignis löschen'
  },

  // Providers
  providers: {
    title: 'Behandler',
    add: 'Behandler hinzufügen',
    edit: 'Behandler bearbeiten',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon',
    specialization: 'Spezialisierung',
    schedule: 'Zeitplan',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    workingHours: 'Arbeitszeiten',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    dayOff: 'Frei',
    saveSchedule: 'Zeitplan speichern',
    scheduleUpdated: 'Zeitplan erfolgreich aktualisiert'
  },

  // Procedures
  procedures: {
    title: 'Behandlungen',
    add: 'Behandlung hinzufügen',
    edit: 'Behandlung bearbeiten',
    name: 'Name',
    description: 'Beschreibung',
    duration: 'Dauer (Minuten)',
    price: 'Preis',
    category: 'Kategorie',
    color: 'Farbe',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    categories: {
      consultation: 'Beratung',
      cleaning: 'Reinigung',
      filling: 'Füllung',
      crown: 'Krone',
      implant: 'Implantat',
      veneer: 'Veneer',
      extraction: 'Extraktion',
      root_canal: 'Wurzelbehandlung',
      orthodontics: 'Kieferorthopädie',
      surgery: 'Chirurgie',
      other: 'Andere'
    }
  },

  // Operatories
  operatories: {
    title: 'Behandlungsräume',
    add: 'Behandlungsraum hinzufügen',
    edit: 'Behandlungsraum bearbeiten',
    name: 'Name',
    description: 'Beschreibung',
    equipment: 'Ausstattung',
    capacity: 'Kapazität',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    location: 'Standort',
    floor: 'Etage',
    room: 'Raum',
    specialEquipment: 'Spezialausrüstung'
  },

  // Status
  status: {
    scheduled: 'Geplant',
    confirmed: 'Bestätigt',
    completed: 'Abgeschlossen',
    cancelled: 'Storniert',
    no_show: 'Nicht erschienen',
    pending: 'Ausstehend',
    approved: 'Genehmigt',
    rejected: 'Abgelehnt',
    active: 'Aktiv',
    inactive: 'Inaktiv'
  },

  // Messages
  messages: {
    appointmentCreated: 'Termin erfolgreich erstellt',
    appointmentUpdated: 'Termin erfolgreich aktualisiert',
    appointmentDeleted: 'Termin erfolgreich gelöscht',
    appointmentCancelled: 'Termin erfolgreich storniert',
    providerCreated: 'Behandler erfolgreich erstellt',
    providerUpdated: 'Behandler erfolgreich aktualisiert',
    providerDeleted: 'Behandler erfolgreich gelöscht',
    procedureCreated: 'Behandlung erfolgreich erstellt',
    procedureUpdated: 'Behandlung erfolgreich aktualisiert',
    procedureDeleted: 'Behandlung erfolgreich gelöscht',
    operatoryCreated: 'Behandlungsraum erfolgreich erstellt',
    operatoryUpdated: 'Behandlungsraum erfolgreich aktualisiert',
    operatoryDeleted: 'Behandlungsraum erfolgreich gelöscht',
    saveSuccess: 'Änderungen erfolgreich gespeichert',
    deleteSuccess: 'Element erfolgreich gelöscht',
    confirmDelete: 'Möchten Sie dieses Element wirklich löschen?',
    confirmCancel: 'Möchten Sie diesen Termin wirklich stornieren?',
    conflictDetected: 'Ein Terminkonflikt wurde erkannt',
    googleCalendarSynced: 'Google Calendar erfolgreich synchronisiert',
    googleCalendarError: 'Fehler beim Synchronisieren mit Google Calendar',
    googleCalendarSync: 'Synchronisiert mit Google Calendar...',
    exportSuccess: 'Daten erfolgreich exportiert',
    importSuccess: 'Daten erfolgreich importiert',
    noDataToExport: 'Keine Daten zum Exportieren vorhanden',
    invalidFileFormat: 'Ungültiges Dateiformat',
    networkError: 'Netzwerkfehler. Bitte versuchen Sie es erneut.',
    sessionExpired: 'Sitzung abgelaufen. Bitte melden Sie sich erneut an.',
    accessDenied: 'Zugriff verweigert',
    formValidationError: 'Bitte korrigieren Sie die Fehler im Formular',
    requiredField: 'Dieses Feld ist erforderlich',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    invalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
    invalidDate: 'Bitte geben Sie ein gültiges Datum ein',
    invalidTime: 'Bitte geben Sie eine gültige Zeit ein',
    startTimeAfterEndTime: 'Startzeit muss vor Endzeit liegen',
    duplicateEntry: 'Dieser Eintrag existiert bereits',
    noResults: 'Keine Ergebnisse gefunden',
    loadingData: 'Daten werden geladen...',
    noDataAvailable: 'Keine Daten verfügbar'
  },

  // Reports
  reports: {
    title: 'Berichte',
    appointmentReport: 'Terminbericht',
    providerReport: 'Behandlerbericht',
    procedureReport: 'Behandlungsbericht',
    revenueReport: 'Umsatzbericht',
    cancellationReport: 'Stornierungsbericht',
    noShowReport: 'Nicht-Erscheinen-Bericht',
    dateRange: 'Datumsbereich',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    generateReport: 'Bericht erstellen',
    exportReport: 'Bericht exportieren',
    printReport: 'Bericht drucken',
    reportGenerated: 'Bericht erfolgreich erstellt',
    noDataForReport: 'Keine Daten für die ausgewählten Kriterien verfügbar',
    totalAppointments: 'Gesamttermine',
    completedAppointments: 'Abgeschlossene Termine',
    cancelledAppointments: 'Stornierte Termine',
    noShowAppointments: 'Nicht-Erscheinen-Termine',
    totalRevenue: 'Gesamtumsatz',
    averageRevenue: 'Durchschnittsumsatz',
    topProcedures: 'Top-Behandlungen',
    topProviders: 'Top-Behandler',
    appointmentsByStatus: 'Termine nach Status',
    appointmentsByProvider: 'Termine nach Behandler',
    appointmentsByProcedure: 'Termine nach Behandlung',
    dailyAppointments: 'Tägliche Termine',
    weeklyAppointments: 'Wöchentliche Termine',
    monthlyAppointments: 'Monatliche Termine'
  },

  // Settings
  settings: {
    title: 'Einstellungen',
    general: 'Allgemein',
    notifications: 'Benachrichtigungen',
    googleCalendar: 'Google Calendar',
    backup: 'Backup',
    users: 'Benutzer',
    clinicName: 'Klinikname',
    clinicAddress: 'Klinikadresse',
    clinicPhone: 'Kliniktelefon',
    clinicEmail: 'Klinik-E-Mail',
    timezone: 'Zeitzone',
    language: 'Sprache',
    dateFormat: 'Datumsformat',
    timeFormat: 'Zeitformat',
    currency: 'Währung',
    emailNotifications: 'E-Mail-Benachrichtigungen',
    smsNotifications: 'SMS-Benachrichtigungen',
    reminderTime: 'Erinnerungszeit',
    calendarId: 'Kalender-ID',
    apiKey: 'API-Schlüssel',
    clientId: 'Client-ID',
    clientSecret: 'Client-Secret',
    testConnection: 'Verbindung testen',
    connectionSuccessful: 'Verbindung erfolgreich',
    connectionFailed: 'Verbindung fehlgeschlagen',
    backupDatabase: 'Datenbank sichern',
    restoreDatabase: 'Datenbank wiederherstellen',
    backupCreated: 'Backup erfolgreich erstellt',
    backupRestored: 'Backup erfolgreich wiederhergestellt',
    addUser: 'Benutzer hinzufügen',
    editUser: 'Benutzer bearbeiten',
    role: 'Rolle',
    permissions: 'Berechtigungen',
    admin: 'Admin',
    user: 'Benutzer',
    viewer: 'Betrachter'
  },

  // Booking form (original content)
  booking: {
    title: 'Termin vereinbaren',
    subtitle: 'Vereinbaren Sie einen Termin mit unserem erfahrenen Team',
    form: {
      name: 'Vollständiger Name',
      email: 'E-Mail-Adresse',
      phone: 'Telefonnummer',
      service: 'Behandlung',
      date: 'Wunschtermin',
      time: 'Wunschzeit',
      message: 'Zusätzliche Anmerkungen',
      language: 'Bevorzugte Sprache',
      submit: 'Termin buchen',
      submitting: 'Wird gesendet...',
      success: 'Ihre Terminanfrage wurde erfolgreich übermittelt!',
      error: 'Bei der Übermittlung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
      required: 'Dieses Feld ist erforderlich'
    },
    services: {
      consultation: 'Beratung',
      cleaning: 'Reinigung',
      filling: 'Füllung',
      crown: 'Krone',
      implant: 'Implantat',
      veneer: 'Veneer',
      extraction: 'Extraktion',
      root_canal: 'Wurzelbehandlung',
      orthodontics: 'Kieferorthopädie',
      surgery: 'Chirurgie',
      other: 'Andere'
    },
    languages: {
      english: 'Englisch',
      german: 'Deutsch',
      spanish: 'Spanisch',
      russian: 'Russisch'
    },
    times: {
      morning: '9:00',
      midMorning: '10:00',
      lateMorning: '11:00',
      noon: '12:00',
      afternoon: '14:00',
      midAfternoon: '15:00',
      lateAfternoon: '16:00',
      evening: '17:00'
    }
  },

  // Hero Section
  hero: {
    title: 'SeaDent Mallorca: Ihr Lächeln zählt.',
    subtitle: 'Moderne Zahnmedizin mit Einfühlungsvermögen. Entspannte Atmosphäre, exzellente Ergebnisse.',
    description: 'Erleben Sie erstklassige Zahnmedizin im Herzen von Mallorca. Unsere moderne Klinik verbindet deutsche Präzision mit mediterraner Wärme.',
    cta: 'Online Termin buchen',
    emergency: 'Notfall anrufen',
    banner: {
      title: "Individueller Komfort - den Sie spüren",
      subtitle: "(und warum unsere Patienten so gerne wiederkommen)",
      buttons: {
        cosmetic: "Ästhetische Zahnmedizin",
        pediatric: "Kinderzahnheilkunde",
        general: "Allgemeine Zahnmedizin",
        whitening: "Zahnaufhellung"
      }
    }
  },

  // Booking Wizard
  bookingWizard: {
    steps: {
      treatment: "Welche Art von Termin?",
      insurance: "Wählen Sie Ihre Versicherung",
      dateTime: "Wunschtermin & Zeit wählen"
    },
    treatments: {
      cleaning: "Professionelle Zahnreinigung + Untersuchung (Zahnarzt)",
      returningCleaning: "Wiederkehrende Patienten-Zahnreinigung (Zahnprophylaxe-Assistent) + Untersuchung (Zahnarzt)",
      consultation: "Allgemeine Zahnärztliche Beratung (Zahnarzt)",
      cosmetic: "Ästhetische Zahnärztliche Beratung (Zahnarzt)",
      secondOpinion: "Zweitmeinung Zahnärztliche Beratung (Zahnarzt)",
      emergency: "Zahnärztlicher Notfalltermin (Röntgenaufnahmen + Zahnarztuntersuchung)",
      whitening: "Professionelle Zahnaufhellungsbehandlung",
      botox: "Botox-Beratung (Zahnarzt)",
      tmj: "Kiefergelenk (Kieferschmerz) Beratung (Zahnarzt)",
      pediatric: "Kinderzahnheilkunde (Zahnmedizin für Kinder)"
    },
    insurance: {
      search: "Versicherung eingeben",
      none: "Ich habe keine Versicherung"
    },
    navigation: {
      back: "Zurück",
      next: "Weiter",
      close: "Schließen"
    },
    getDirections: "Wegbeschreibung",
    instantBookingBy: "Sofortige Buchung durch"
  },

  // Services Section
  services: {
    title: 'Unsere Leistungen',
    subtitle: 'Umfassende Zahnmedizin',
    implants: {
      title: 'Zahnimplantate',
      description: 'Dauerhafte Lösung für fehlende Zähne mit Titanimplantaten'
    },
    veneers: {
      title: 'Veneers',
      description: 'Verwandeln Sie Ihr Lächeln mit individuellen Porzellanveneers'
    },
    cleaning: {
      title: 'Professionelle Reinigung',
      description: 'Gründliche Reinigung und Vorsorge für optimale Mundgesundheit'
    },
    crown: {
      title: 'Kronen & Brücken',
      description: 'Wiederherstellung beschädigter Zähne mit hochwertigen Kronen und Brücken'
    },
    orthodontics: {
      title: 'Kieferorthopädie',
      description: 'Begradigen Sie Ihre Zähne mit modernen kieferorthopädischen Behandlungen'
    },
    surgery: {
      title: 'Oralchirurgie',
      description: 'Expertenhafte chirurgische Eingriffe in unseren modernen Operationssälen'
    }
  },

  // Treatments Section
  treatments: {
    title: "Behandlungen: Ihr Lächeln in besten Händen",
    intro: "Unsere Behandlungen bei SeaDent Mallorca umfassen das gesamte Spektrum der modernen Zahnmedizin – von der Vorsorge bis zur ästhetischen Perfektion. Mit fortschrittlicher Technologie und einfühlsamer Betreuung sorgen wir für Ihre Mundgesundheit und ein strahlendes Lächeln.",
    cta: "Jetzt Termin vereinbaren",
    categories: [
      {
        title: "Vorsorge und Prophylaxe",
        description: "Regelmäßige Kontrollen und präventive Maßnahmen für eine langfristige Mundgesundheit. Wir setzen auf individuelle Beratung und moderne Diagnostik.",
        treatments: [
          {
            title: "Kontrolle und Beratung",
            description: "Ausführliche Untersuchungen und persönliche Empfehlungen für gesunde Zähne."
          },
          {
            title: "Professionelle Zahnreinigung",
            description: "Gründliche Entfernung von Zahnbelag für ein sauberes und frisches Gefühl."
          },
          {
            title: "Füllungen",
            description: "Hochwertige Füllungen, die Ihre Zähne ästhetisch und funktional wiederherstellen."
          },
          {
            title: "Kinderprophylaxe",
            description: "Kindgerechte Vorsorge, um die Zähne Ihrer Kleinen spielerisch zu schützen."
          }
        ]
      },
      {
        title: "Schmerztherapie",
        description: "Schmerzfreie Behandlungen durch sanfte Techniken und modernste Technologien. Ihr Wohlbefinden steht bei jeder Sitzung im Mittelpunkt.",
        treatments: [
          {
            title: "Schmerzbehandlung",
            description: "Schnelle und effektive Linderung von Zahnschmerzen, individuell auf Sie abgestimmt."
          },
          {
            title: "Zahnentfernung",
            description: "Schonende Entfernung von Zähnen, wenn keine andere Lösung möglich ist."
          },
          {
            title: "Wurzelbehandlung",
            description: "Präzise Endodontie zur Rettung entzündeter Zähne und Schmerzlinderung."
          },
          {
            title: "Kiefergelenksprobleme",
            description: "Gezielte Therapie bei Kiefergelenksproblemen (TMJ) für bessere Lebensqualität."
          }
        ]
      },
      {
        title: "Parodontitis",
        description: "Professionelle Behandlung von Zahnfleischerkrankungen für eine stabile Mundgesundheit. Frühzeitige Maßnahmen verhindern langfristige Schäden.",
        treatments: [
          {
            title: "Behandlungsmaßnahmen",
            description: "Professionelle Reinigung und Therapien zur effektiven Bekämpfung von Zahnfleischentzündungen."
          }
        ]
      },
      {
        title: "Für ein perfektes Lächeln (Ästhetik)",
        description: "Ästhetische Lösungen für ein selbstbewusstes Lächeln, ganz nach Ihren Wünschen. Unsere Methoden sind schonend und effektiv.",
        treatments: [
          {
            title: "Invisalign",
            description: "Transparente Aligner für eine diskrete und komfortable Zahnkorrektur."
          },
          {
            title: "Zahnaufhellung",
            description: "Schonende Aufhellung Ihrer Zähne für ein strahlendes, weißes Lächeln."
          },
          {
            title: "Knirschschienen",
            description: "Maßgeschneiderte Schienen zur Vorbeugung von Zähneknirschen und Schutz Ihres Gebisses."
          },
          {
            title: "Veneers",
            description: "Hauchdünne Keramikschalen für ein perfektes und natürliches Aussehen Ihrer Zähne."
          },
          {
            title: "Kronen und Brücken",
            description: "Hochwertiger Zahnersatz für Funktion und Ästhetik bei beschädigten Zähnen."
          }
        ]
      },
      {
        title: "Implantate",
        description: "Modernste Implantattechnologie für einen natürlichen und dauerhaften Zahnersatz. Unsere Implantate bieten Ihnen Komfort und Sicherheit.",
        treatments: [
          {
            title: "Einzelimplantate",
            description: "Ersatz einzelner Zähne mit hochwertigen Implantaten für ein natürliches Gefühl."
          },
          {
            title: "Mehrfachimplantate",
            description: "Umfassende Implantatlösungen für größere Zahnlücken oder komplette Zahnreihen."
          },
          {
            title: "Sofortimplantate",
            description: "Implantate mit sofortiger Belastung für eine schnelle Wiederherstellung Ihrer Kaufunktion."
          }
        ]
      }
    ]
  },

  // Benefits Section
  benefits: {
    title: 'Ihre Vorteile: Exzellenz, Komfort und ein Lächeln, das strahlt.',
    items: [
      {
        title: 'Erfahrung und Kompetenz',
        description: 'Qualifizierte Zahnärzte mit kontinuierlicher Fortbildung.'
      },
      {
        title: 'Modernste Technologie',
        description: 'Präzise Behandlungen mit digitalem Röntgen und innovativen Geräten.'
      },
      {
        title: 'Patientenzentrierte Betreuung',
        description: 'Einfühlsame Behandlung, wie Sie sie von einem Freund erwarten würden.'
      },
      {
        title: 'Mediterrane Atmosphäre',
        description: 'Eine entspannte Umgebung inspiriert von der Schönheit Mallorcas.'
      },
      {
        title: 'Mehrsprachiger Service',
        description: 'Behandlung auf Deutsch, Englisch, Spanisch und Russisch.'
      },
      {
        title: 'Zentrale Lage',
        description: 'Leicht erreichbar im Herzen von Palma de Mallorca.'
      }
    ]
  },

  // Approach Section
  approach: {
    title: 'Zahnmedizin neu gedacht: Ihr Wohlbefinden, unser Versprechen.',
    text: 'Bei SeaDent möchten wir, dass Ihr Zahnarztbesuch etwas Besonderes wird. Unsere Mission ist es, Ihnen nicht nur medizinisch exzellente Behandlungen, sondern auch eine Atmosphäre zu bieten, in der Sie sich entspannt und verstanden fühlen. Das bedeutet für uns:',
    points: [
      'Wir hören zu: Ihre Wünsche und Bedürfnisse stehen im Mittelpunkt unserer Betreuung. Wir nehmen uns Zeit für eine individuelle Beratung.',
      'Entspannung und schmerzfreie Behandlungen: Mit modernsten Methoden und dem Fokus auf Ihr Wohlbefinden machen wir Behandlungen so komfortabel wie möglich.',
      'Transparenz schafft Vertrauen: Wir erklären jeden Schritt Ihrer Behandlung klar und verständlich, damit Sie sich sicher fühlen.'
    ]
  },

  // Team Section
  team: {
    title: 'Unser Team',
    subtitle: 'Experten für Ihr Lächeln',
    description: 'Unser erfahrenes Team aus Zahnärzten und Dentalhygienikern widmet sich der bestmöglichen Versorgung.',
    cta: 'Lernen Sie unser Team kennen'
  },

  // Experience Section
  experience: {
    title: 'Ihre Wohlfühlmomente bei SeaDent Mallorca.',
    text: 'Bei SeaDent geht es um mehr als nur Zahnmedizin – wir möchten, dass Ihr Besuch zu einem Moment der Entspannung wird. Unsere Praxis verbindet modernste Behandlungen mit einer Atmosphäre, die von der Ruhe und Schönheit Mallorcas inspiriert ist.',
    points: [
      'Einladende Atmosphäre mit mediterranen Farben und natürlichem Licht.',
      'Freundliches und einfühlsames Team, das Sie herzlich willkommen heißt.',
      'Kurze Wartezeiten dank effizienter Praxisorganisation.',
      'Komfortable Wartebereiche mit WLAN, Getränken und Pflanzen.',
      'Entspannende Details wie beruhigende Musik während der Behandlung.'
    ]
  },

  // Social Proof Section
  socialProof: {
    title: "Was unsere Patienten sagen",
    reviews: [
      {
        text: "Fachlich top, menschlich großartig, hier fühlt man sich wirklich gut aufgehoben ❤️. Ein riesiges Dankeschön an den Zahnarzt und das ganze Team. So stelle ich mir eine moderne, herzliche Praxis vor 🦷🤗.",
        author: "Marcel"
      },
      {
        text: "So einen engagierten, herzlichen und ehrlichen Zahnarzt habe ich noch nie erlebt. Er nimmt sich immer viel Zeit – sogar außerhalb der normalen Praxiszeiten – und ist jederzeit für seine Patienten da. Die Behandlungen sind professionell und werden mit viel Empathie durchgeführt. Auch nach dem Termin kümmert er sich um die Nachsorge und möchte wissen, wie es einem geht – das ist alles andere als selbstverständlich. Ein absolut toller Zahnarzt, dem man voll und ganz vertrauen kann. Absolute Empfehlung!",
        author: "Stefanie"
      },
      {
        text: "Top Zahnarzt!!! Ich bekam natürlich genau im Urlaub extreme Zahnschmerzen nach einer Füllung die ein paar Wochen her war. Warten bis ich zu Hause in Deutschland zur Zahnarztin gehen kann, war nicht möglich. Ich bekam bei Jan D. Heiringhoff sofort einen Termin. Er ist super sympathisch, hört zu, stellt Fragen und hat die nötige Wurzelkanalbehandlung super gemacht. Meine Zahnärztin in Deutschland meinte danach, dass er die Wurzelkanalbehandlung super gemacht hat. Ich hatte während der Behandlung und danach keine Probleme oder sogar Schmerzen. Ich kann ihn bestens weiter empfehlen!",
        author: "Hendrik"
      },
      {
        text: "Ich war wirklich sehr froh, nach einer schlaflosen Nacht, wegen akuten Zahnschmerzen, eine schnelle und unkomplizierte Antwort zu bekommen. Die Behandlung, erfolgte auch prompt und professionell. Schön, dass es noch Ärzte gibt, die auch am Samstag arbeiten und dabei noch sehr freundlich und kompetent sind. Vielen Dank.",
        author: "T."
      },
      {
        text: "Sofortige (!) und professionelle Notfallbehandlung. Transparent und auf Augenhöhe. Vielen Dank an das Team, ich habe mich sehr gut aufgehoben gefühlt. NACHTRAG (einige Monate später): Zurück in der Praxis und diesmal Bleaching in Anspruch genommen. Alles professionell und freundlich. Einfach eine empfehlenswerte Praxis! 👍",
        author: "Hubert"
      },
      {
        text: "Ich wurde super freundlich empfangen und behandelt. Dr. Heiringhoff hat sich viel Zeit genommen und alles ausführlich erklärt. Er hat auf meinen Wunsch hin 2 Röntgenaufnahmen meiner neuen Krone gemacht. Ich hatte Angst, eine Wurzelentzündung zu haben. Dem war nicht so und ich konnte beruhigt gehen. Ich kann Dr. Heiringhoff unbedingt weiterempfehlen. Danke, für die schnelle Hilfe an einem Sonntag ☺️.",
        author: "Elke"
      },
      {
        text: "Meine Zähne sahen vorher ehrlich gesagt richtig crack aus – so, dass ich auf Fotos lieber ernst geguckt hab, als zu lächeln. Aber dann kam Jan! Der Typ hat aus meinem Gebiss ein Lächeln gemacht, das sich sehen lassen kann. Super entspannt, null Zahnarzt-Angst und echt mit Liebe zum Detail. Jetzt grins ich wieder, als wär ich frisch aus der Zahnpasta-Werbung. Danke, Jan – du bist mein Zahnheld!",
        author: "Patrick"
      },
      {
        text: "Vielen Dank für die schnelle Hilfe. Hatte während des Urlaubs einen Zahnnotfall. Bekam sofort einen Termin, wo ich super beraten und behandelt wurde. Empfehlung von Herzen.",
        author: "Simone"
      }
    ]
  },

  // Technologies Section
  technologies: {
    title: 'Moderne Technologie',
    subtitle: 'Hochmoderne Ausstattung',
    intro: 'Bei SeaDent legen wir Wert auf eine individuelle, angenehme und schmerzfreie Zahnmedizin durch den Einsatz modernster Technik.',
    sections: [
      {
        title: 'Digitale Zahnheilkunde',
        description: 'Digitale Abformungen und 3D-Visualisierung für eine präzise Diagnostik und Behandlungsplanung.',
        benefits: [
          'Schnelle und bequeme digitale Zahnerfassung.',
          'Deutlich höherer Komfort als bei Abdrücken.',
          'Möglichkeit zur Visualisierung Ihrer Behandlungsergebnisse.',
          'Trägt zu einer schnelleren und angenehmeren Behandlung bei.'
        ]
      },
      {
        title: 'Dentallaser: Das heilende Licht',
        description: 'Ein Dentallaser ist ein vielseitiges Instrument, das viele herkömmliche Werkzeuge ersetzt und die Heilung unterstützt. Er arbeitet genau, effizient und sicher. Nutzen des Dentallasers für Sie:',
        benefits: [
          'Unterstützt die Heilung von Zahnfleisch, Knochen und mehr.',
          'Ermöglicht kleinere chirurgische Eingriffe.',
          'Hilft bei der Sterilisation von Wurzelkanälen.',
          'Wird zur Blutstillung bei Eingriffen eingesetzt.',
          'Effektive Behandlung von Aphten und Herpes.',
          'Unterstützt die Parodontitisbehandlung.',
          'Hilft bei der Desensibilisierung empfindlicher Zahnhälse.'
        ]
      },
      {
        title: 'Implantattechnologie',
        description: 'Fortschrittliche Implantatsysteme für optimale Einheilung und langfristigen Erfolg.',
        benefits: [
          'Hochwertige Materialien (Titan/Keramik)',
          'Computergestützte Planung für maximale Sicherheit',
          'Langlebige und ästhetische Ergebnisse'
        ]
      },
      {
        title: 'Dentalmikroskop',
        description: 'Mikroskopische Präzision für endodontische Behandlungen und feinste chirurgische Eingriffe.',
        benefits: [
          'Maximale Detailgenauigkeit',
          'Höhere Erfolgsraten bei Wurzelbehandlungen',
          'Minimalinvasives Vorgehen'
        ]
      }
    ],
    conclusion: 'Durch die Kombination dieser modernen Technologien mit unserem Fokus auf Vertrauen und Transparenz erleben Sie bei SeaDent eine Zahnmedizin, die professionell, angenehm und persönlich ist.'
  },

  cta: {
    title: 'Erleben Sie Zahnmedizin, die Sie in den Mittelpunkt stellt.',
    text: 'Bereit für eine Zahnarztpraxis, die Professionalität mit mediterranem Komfort verbindet? Vereinbaren Sie Ihren Termin bei SeaDent Mallorca und entdecken Sie eine neue Art der Zahnmedizin – wir freuen uns, Sie in Palma willkommen zu heißen!',
    bookButton: 'Online Termin buchen',
    callButton: 'Rufen Sie uns an',
    visitInfo: 'Besuchen Sie uns: Avenida de Jaime III № 3, Palma, Mallorca.'
  },

  // Footer
  footer: {
    legal: {
      title: 'Impressum',
      privacy: 'Datenschutz',
      cookieSettings: 'Cookie-Einstellungen'
    },
    links: {
      title: 'Navigation',
      home: 'Startseite',
      contact: 'Kontakt',
      book: 'Termin buchen'
    },
    contact: {
      title: 'Kontaktinformationen',
      practice: 'SeaDent Mallorca',
      address: 'Avenida de Jaime III, № 3',
      city: '07012 Palma de Mallorca',
      owner: 'Inhaber: Jan D. Heiringhoff',
      phone: '603 31 96 48',
      whatsapp: 'WhatsApp: 603 31 96 48',
      email: 'info@seadent.es',
      hours: 'Mo-Fr: 09:00 - 18:00'
    },
    copyright: '© 2024 SeaDent Mallorca. Alle Rechte vorbehalten.'
  },

  // Contact
  contact: {
    title: 'Kontaktieren Sie uns',
    subtitle: 'Nehmen Sie Kontakt auf',
    contactInfo: 'Kontaktinformationen',
    address: 'Adresse',
    phone: 'Telefon',
    email: 'E-Mail',
    emergencyTitle: 'Notfallservice',
    emergencyText: 'Für Notfälle steht Ihnen ein 24/7-Service zur Verfügung',
    appointment: 'Terminvereinbarung',
    findUsTitle: 'Wo Sie uns finden',
    directionsButton: 'Anfahrt anzeigen',
    transportTitle: 'Anfahrt',
    publicTransport: 'Öffentliche Verkehrsmittel',
    publicTransportInfo: 'Wir befinden uns im Herzen von Palma, in der Nähe der wichtigsten Bushaltestellen an der Jaime III.',
    byCar: 'Mit dem Auto',
    byCarInfo: 'Mehrere öffentliche Parkplätze befinden sich in der Nähe, darunter das Parking Vía Roma und El Corte Inglés.',
    form: {
      name: 'Name',
      email: 'E-Mail',
      subject: 'Betreff',
      message: 'Nachricht',
      send: 'Nachricht senden',
      success: 'Nachricht erfolgreich gesendet!',
      error: 'Fehler beim Senden der Nachricht. Bitte versuchen Sie es erneut.'
    }
  },

  // Emergency
  emergency: {
    title: 'Zahnnotfall',
    subtitle: 'Wir sind 24/7 für Sie da',
    intro: 'Wenn Sie einen Zahnnotfall haben, kontaktieren Sie uns sofort. Unser Notfallteam ist rund um die Uhr verfügbar, um Ihnen die benötigte Behandlung zu bieten.',
    call: 'Jetzt anrufen',
    whatsapp: 'WhatsApp',
    cta: 'Rufen Sie 603 31 96 48 an',
    details: [
      {
        title: 'Verfügbarkeit',
        description: 'Unser Notfallteam ist 24 Stunden am Tag, 365 Tage im Jahr erreichbar, auch an Wochenenden und Feiertagen.'
      },
      {
        title: 'Kontakt',
        description: 'Rufen Sie uns unter 603 31 96 48 an, um sofortige Hilfe zu erhalten. Wir akzeptieren auch WhatsApp-Nachrichten.'
      },
      {
        title: 'Häufige Notfälle',
        description: 'Wir behandeln starke Zahnschmerzen, abgebrochene Zähne, ausgeschlagene Zähne und andere Zahntraumata.'
      },
      {
        title: 'Service',
        description: 'Wir bieten sofortige Schmerzlinderung und langfristige Lösungen unter Einsatz modernster Zahntechnik.'
      }
    ],
    common: {
      title: 'Häufige Zahnnotfälle',
      toothache: 'Starke Zahnschmerzen',
      broken: 'Gebrochener oder angeschlagener Zahn',
      knocked: 'Ausgeschlagener Zahn',
      bleeding: 'Zahnfleischbluten',
      swelling: 'Gesichtsschwellung',
      lost: 'Verlorene Füllung oder Krone'
    },
    instructions: {
      title: 'Was zu tun ist',
      toothache: 'Spülen Sie mit warmem Salzwasser und nehmen Sie rezeptfreie Schmerzmittel.',
      broken: 'Bewahren Sie alle Teile auf und spülen Sie den Mund mit warmem Wasser.',
      knocked: 'Fassen Sie den Zahn an der Krone, nicht an der Wurzel an. Halten Sie ihn feucht.',
      bleeding: 'Üben Sie sanften Druck mit einem sauberen Tuch oder Gaze aus.',
      swelling: 'Legen Sie eine kalte Kompresse auf die Außenseite Ihrer Wange.',
      lost: 'Halten Sie den Bereich sauber und vermeiden Sie das Kauen auf dieser Seite.'
    }
  }
}; 